import { Link } from "react-router-dom";
import Reveal from "@/components/base/Reveal";
import { services } from "@/mocks/site";

export default function ServicesSection() {
  return (
    <section className="bg-background-50 px-4 md:px-10 py-16 md:py-24">
      <Reveal className="text-center">
        <h2 className="font-heading text-2xl md:text-4xl tracking-tight text-foreground-950">
          WHAT WE DO
        </h2>
      </Reveal>

      <div className="mx-auto mt-12 grid max-w-6xl grid-cols-1 gap-10 sm:grid-cols-2 lg:grid-cols-4 lg:gap-8">
        {services.map((service, index) => (
          <Reveal key={service.title} delay={index * 100}>
            <div className="flex h-full flex-col border-t border-background-300 pt-5">
              <h3 className="font-heading text-base text-foreground-950">{service.title}</h3>
              <p className="mt-3 flex-1 text-sm leading-relaxed text-foreground-600">
                {service.description}
              </p>
              <Link
                to={service.linkHref}
                className="mt-4 inline-flex items-center gap-1 text-sm italic text-foreground-700 underline decoration-accent-400 decoration-1 underline-offset-4 transition-colors hover:text-accent-700"
              >
                → {service.linkLabel}
              </Link>
            </div>
          </Reveal>
        ))}
      </div>
    </section>
  );
}